import { getChangelog } from "/app/src/routes/{-$locale}/offers/$id/changelog.tsx?tsr-shared=1";
const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/offers/$id/changelog.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { getQueryClient } from "@/lib/client";
import { generateOfferMeta } from "@/lib/generate-offer-meta";
import { getFetchedQuery } from "@/lib/get-fetched-query";
import { offerOnlyQueryOptions } from "@/queries/offer-gql";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/lib/i18n";
type ChangelogWithPagination = {
  elements: Change[];
  page: number;
  limit: number;
  totalCount: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
};
type LoaderData = {
  dehydratedState: DehydratedState;
  id: string;
  offer: SingleOffer | null;
  locale: string | undefined;
};
export const Route = createFileRoute("/{-$locale}/offers/$id/changelog")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    params,
    context
  }) => {
    const {
      queryClient,
      locale
    } = context;
    const {
      id
    } = params;
    const offer = await queryClient.ensureQueryData(offerOnlyQueryOptions(params.id, locale));
    await queryClient.prefetchQuery(getChangelog(id, 1));
    return {
      id,
      locale,
      offer,
      dehydratedState: dehydrate(queryClient)
    };
  },
  head: ctx => {
    const {
      params
    } = ctx;
    const queryClient = getQueryClient();
    if (!ctx.loaderData) {
      return {
        meta: [{
          title: i18n.t("offerDetail.common.offerNotFound"),
          description: i18n.t("offerDetail.common.offerNotFound")
        }]
      };
    }
    const offer = getFetchedQuery<SingleOffer>(queryClient, ctx.loaderData?.dehydratedState, [...offerOnlyQueryOptions(params.id, ctx.loaderData?.locale).queryKey]);
    if (!offer) {
      return {
        meta: [{
          title: i18n.t("offerDetail.common.offerNotFound"),
          description: i18n.t("offerDetail.common.offerNotFound")
        }]
      };
    }
    return {
      meta: generateOfferMeta(offer, "Changelog")
    };
  }
});